import { render } from "./DeviceSelector.vue?vue&type=template&id=dd52a988"
import script from "./DeviceSelector.vue?vue&type=script&lang=js"
export * from "./DeviceSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__